/*
  Vorbestellungs-Zustand auf Produktseite und Quick-View.

  Schaltet Liefer-Chip, Hinweis unter dem Knopf, Knopf-Text, das Feld
  properties[Vorbestellung] sowie Angebotskasten und Versand-Countdown
  (snippets/gp-pdp-offer) um, wenn die Variante gewechselt wird – ohne Reload.

  Datenquelle ist das von Liquid gerenderte <script type="application/json"
  data-gp-preorder-map> (Regel: snippets/gp-preorder-state.liquid). Pro Varianten-ID:
  { pre, note, chip, prop } – fertige, lokalisierte Texte (locales → preorder.*).
  Ältere Maps mit true/false oder { pre, date } werden weiter verstanden.

  Das Theme feuert "VARIANT_CHANGE" nicht zuverlässig, deshalb zusätzlich "change"
  und ein kurzes Nachfassen. Quick-View-Inhalte kommen per JS nach: ein
  MutationObserver initialisiert neue Maps.
*/
(function () {
  'use strict';

  function init(mapEl) {
    if (mapEl.hasAttribute('data-gp-init')) { return; }
    mapEl.setAttribute('data-gp-init', '');

    // Map, Chips, Hinweis und Knopf liegen im Produktformular (Produktseite und Quick-View)
    var form = mapEl.closest('product-form');
    if (!form) { return; }
    var root = form;

    var cfg;
    try { cfg = JSON.parse(mapEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.variants) { return; }
    var texts = cfg.texts || {};

    function q(sel) { return root.querySelector(sel); }
    var chipStock = q('[data-gp-chip-stock]');
    var chipPre = q('[data-gp-chip-preorder]');
    var chipText = q('[data-gp-chip-text]');
    var note = q('[data-gp-preorder-note]');
    var noteTitle = q('[data-gp-preorder-title]');
    var btnText = q('[data-js-product-add-to-cart-text]');

    function toggle(el, hidden) {
      if (!el) { return; }
      if (hidden) { el.setAttribute('data-gp-hidden', ''); }
      else { el.removeAttribute('data-gp-hidden'); }
    }

    var lastId = null;
    var urgencyOff = true;
    var urgencyAt = 0;

    function apply() {
      var input = form.querySelector('[name="id"]');
      var id = input ? String(input.value) : null;
      if (!id) { return; }

      var entry = cfg.variants[id];
      var pre = entry === true || !!(entry && entry.pre);
      if (entry && typeof entry === 'object') {
        if (chipText && entry.chip) { chipText.textContent = entry.chip; }
        if (noteTitle && entry.note) { noteTitle.textContent = entry.note; }
      }
      var prop = q('[data-gp-preorder-prop]');
      if (prop) {
        prop.disabled = !pre;
        if (entry && entry.prop) { prop.value = entry.prop; }
      }

      var atcBtn = q('[data-js-product-add-to-cart]');
      var soldOut = !pre && atcBtn && atcBtn.disabled;
      toggle(chipStock, pre || soldOut);
      toggle(chipPre, !pre);
      toggle(note, !pre);

      // Ausverkaufte Varianten (deny, kein Datum) behalten ihren "Ausverkauft"-Text.
      if (btnText && atcBtn && !atcBtn.hasAttribute('disabled')) {
        btnText.textContent = pre ? (texts.button || 'Jetzt vorbestellen') : (texts.add || btnText.textContent);
      }
      toggle(q('[data-gp-offer-box]'), soldOut);
      var offers = root.querySelectorAll('[data-gp-offer]');
      for (var i = 0; i < offers.length; i++) {
        toggle(offers[i], offers[i].getAttribute('data-gp-offer') !== id);
      }
      urgencyOff = pre || !!soldOut;
      urgency();
      lastId = id;
    }

    // Versand-Countdown über dem Knopf: nur der echte 12-Uhr-Versandschluss, nie bei Vorbestellung
    function urgency() {
      var el = q('[data-gp-urgency]');
      if (!el) { return; }
      var d = window.GPDelivery;
      if (urgencyOff || !d) { toggle(el, true); return; }
      var e = d.estimate();
      el.querySelector('[data-gp-urgency-text]').innerHTML = e.beforeCutoff
        ? '<strong>Noch ' + d.countdown(e.minutesLeft) + '</strong> bestellen – Versand in der Regel heute'
        : 'Jetzt bestellen – Versand voraussichtlich ' + d.format(e.ship);
      toggle(el, false);
    }

    function schedule() { window.setTimeout(apply, 60); }

    form.addEventListener('VARIANT_CHANGE', schedule);
    root.addEventListener('change', schedule, true);

    var timer = window.setInterval(function () {
      if (!document.contains(mapEl)) { window.clearInterval(timer); return; }
      var input = form.querySelector('[name="id"]');
      if (input && String(input.value) !== lastId) { apply(); }
      if (Date.now() - urgencyAt > 30000) { urgencyAt = Date.now(); urgency(); }
    }, 500);

    apply();
  }

  function boot() {
    var maps = document.querySelectorAll('[data-gp-preorder-map]:not([data-gp-init])');
    for (var i = 0; i < maps.length; i++) { init(maps[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Quick-View und andere nachgeladene Produktformulare
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { boot(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
